(() => {
  const SECTION_TYPE = 'custom-partners';

  class CustomPartners {
    constructor(section) {
      this.section = section;
      this.continuous = section.dataset.continuous === 'true';
      this.timerMs = Math.max(3, Math.min(10, Number(section.dataset.timer) || 5)) * 1000;
      this.rows = Array.from(section.querySelectorAll('[data-partners-row]'));
      this.timers = [];
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (this.continuous || this.reducedMotion || !this.rows.length) return;

      this.rows.forEach((row) => this.initTimedRow(row));
    }

    initTimedRow(row) {
      const track = row.querySelector('[data-partners-track]');
      const sequences = row.querySelectorAll('[data-partners-sequence]');
      if (!track || sequences.length < 2) return;

      const sequence = sequences[0];
      const logos = Array.from(sequence.querySelectorAll('[data-partners-logo]'));
      if (!logos.length) return;

      const direction = row.dataset.direction === 'right' ? 'right' : 'left';
      let index = 0;
      let paused = false;

      const getGap = () => {
        const styles = window.getComputedStyle(sequence);
        const gap = Number.parseFloat(styles.columnGap || styles.gap || '0');
        return Number.isFinite(gap) ? gap : 0;
      };

      const offsetForIndex = (logoIndex) => {
        const gap = getGap();
        let offset = 0;
        for (let i = 0; i < logoIndex; i += 1) {
          offset += logos[i].getBoundingClientRect().width + gap;
        }
        return offset;
      };

      const sequenceWidth = () => sequence.getBoundingClientRect().width;

      const applyTransform = (withTransition = true) => {
        if (!withTransition) {
          track.style.transition = 'none';
        } else {
          track.style.transition = '';
        }

        const offset = offsetForIndex(index);
        if (direction === 'left') {
          track.style.transform = `translateX(${-offset}px)`;
        } else {
          track.style.transform = `translateX(${-(sequenceWidth() - offset)}px)`;
        }

        if (!withTransition) {
          void track.offsetWidth;
          track.style.transition = '';
        }
      };

      applyTransform(false);

      const advance = () => {
        if (paused) return;

        index += 1;
        if (index >= logos.length) {
          index = 0;
          applyTransform(false);
          index = 1;
        }
        applyTransform(true);
      };

      const pause = () => {
        paused = true;
      };
      const resume = () => {
        paused = false;
      };
      const onFocusOut = (event) => {
        if (!row.contains(event.relatedTarget)) resume();
      };

      row.addEventListener('mouseenter', pause);
      row.addEventListener('mouseleave', resume);
      row.addEventListener('focusin', pause);
      row.addEventListener('focusout', onFocusOut);

      const timerId = window.setInterval(advance, this.timerMs);
      this.timers.push({
        timerId,
        row,
        pause,
        resume,
        onFocusOut,
      });
    }

    destroy() {
      this.timers.forEach(({ timerId, row, pause, resume, onFocusOut }) => {
        window.clearInterval(timerId);
        row.removeEventListener('mouseenter', pause);
        row.removeEventListener('mouseleave', resume);
        row.removeEventListener('focusin', pause);
        row.removeEventListener('focusout', onFocusOut);
      });
      this.timers = [];
    }
  }

  const instances = new Map();

  function initSection(section) {
    if (!section) return;
    const key = section.id || section.dataset.sectionId;
    if (!key || instances.has(key)) return;
    instances.set(key, new CustomPartners(section));
  }

  function destroySection(sectionId) {
    const key = `CustomPartners-${sectionId}`;
    const instance = instances.get(key) || instances.get(sectionId);
    if (!instance) return;
    instance.destroy();
    instances.delete(key);
    instances.delete(sectionId);
  }

  function boot() {
    document.querySelectorAll(`[data-section-type="${SECTION_TYPE}"]`).forEach(initSection);
  }

  document.addEventListener('DOMContentLoaded', boot);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector(`[data-section-type="${SECTION_TYPE}"]`);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    destroySection(event.detail.sectionId);
  });

  if (document.readyState !== 'loading') boot();
})();
